<ngx-dropzone
  [multiple]="false"
  [expandable]="true"
  (change)="onSelect($event)"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
  <ngx-dropzone-label>
    <i class="pi pi-cloud" style="font-size: 5rem"></i> <br />
    Húzza ide a file-t vagy kattintson a tallózáshoz!
    <br />
    Csak Excel (.xlsx) típusú fileok használhatóak
  </ngx-dropzone-label>
  @for (file of files; track file) {
    <ngx-dropzone-preview
      [removable]="true"
      (removed)="onRemove($event)"
      ngProjectAs="ngx-dropzone-preview"
      [file]="file">
      <ngx-dropzone-label>
        <img style="width: 100px" src="assets/image/excel.png" />
        <div class="trimed">
          {{ file.name }}
        </div>
      </ngx-dropzone-label>
    </ngx-dropzone-preview>
  }
</ngx-dropzone>
@if (files.length > 1) {
  <div>
    <span class="error-message">Csak egy file tölthető fel!</span>
  </div>
}
<div class="flex align-items-center mt-3">
  <img style="width: 30px" src="assets/image/excel.png" />
  <p class="m-0 mx-3">Minta Excel file a helyes kitöltéshez</p>
  <button
    class="p-button small"
    pButton
    label="LETÖLTÉS"
  (click)="uploadService.downloadExample()"></button>
</div>
<div class="flex justify-content-end">
  <button
    [disabled]="files.length === 0 || files.length > 1 || uploadService.uploading"
    class="p-button"
    pButton
    [icon]="uploadService.uploading ? 'pi pi-spin pi-spinner' : ''"
    [label]="uploadService.uploading ? 'Feltöltés folyamatban...' : 'FELTÖLTÉS'"
  (click)="uploadService.importFile(files[0])"></button>
</div>
